import { css } from 'styled-components';

import gtWalsheimProBoldWOFF from 'src/fonts/gt-walsheim-pro/gt-walsheim-pro-bold/gt-walsheim-pro-bold.woff';
import gtWalsheimProBoldWOFF2 from 'src/fonts/gt-walsheim-pro/gt-walsheim-pro-bold/gt-walsheim-pro-bold.woff2';
import gtWalsheimProRegularWOFF from 'src/fonts/gt-walsheim-pro/gt-walsheim-pro-regular/gt-walsheim-pro-regular.woff';
import gtWalsheimProRegularWOFF2 from 'src/fonts/gt-walsheim-pro/gt-walsheim-pro-regular/gt-walsheim-pro-regular.woff2';
import robotoBoldWOFF from 'src/fonts/roboto/roboto-bold/roboto-bold.woff';
import robotoBoldWOFF2 from 'src/fonts/roboto/roboto-bold/roboto-bold.woff2';
import robotoRegularWOFF from 'src/fonts/roboto/roboto-regular/roboto-regular.woff';
import robotoRegularWOFF2 from 'src/fonts/roboto/roboto-regular/roboto-regular.woff2';
import robotoThinWOFF from 'src/fonts/roboto/roboto-thin/roboto-thin.woff';
import robotoThinWOFF2 from 'src/fonts/roboto/roboto-thin/roboto-thin.woff2';

export const fontPrimary = 'Roboto';
export const fontSecondary = 'GT Walsheim Pro';

export const fonts = css`
  @font-face {
    font-family: ${fontPrimary};
    src:
      url(${robotoRegularWOFF2}) format('woff2'),
      url(${robotoRegularWOFF}) format('woff');
  }

  @font-face {
    font-family: ${fontPrimary};
    font-weight: bold;
    src:
      url(${robotoBoldWOFF2}) format('woff2'),
      url(${robotoBoldWOFF}) format('woff');
  }

  @font-face {
    font-family: ${fontPrimary};
    font-weight: 200;
    src:
      url(${robotoThinWOFF2}) format('woff2'),
      url(${robotoThinWOFF}) format('woff');
  }

  @font-face {
    font-family: ${fontSecondary};
    src:
      url(${gtWalsheimProRegularWOFF2}) format('woff2'),
      url(${gtWalsheimProRegularWOFF}) format('woff');
  }

  @font-face {
    font-family: ${fontSecondary};
    font-weight: bold;
    src:
      url(${gtWalsheimProBoldWOFF2}) format('woff2'),
      url(${gtWalsheimProBoldWOFF}) format('woff');
  }
`;
